import { ARM_DATA, CUIRASS_DATA, FACE_DATA, LEG_DATA } from "./currentData";

// 防具类型
export const EQUIPMENT_ITEM = [
  {
    key: "face",
    label: "头冠",
    data: FACE_DATA,
  },
  {
    key: "cuirass",
    label: "胸甲",
    data: CUIRASS_DATA,
  },
  {
    key: "arm",
    label: "臂甲",
    data: ARM_DATA,
  },
  {
    key: "leg",
    label: "腿甲",
    data: LEG_DATA,
  },
];
